import {
  useEmailVerificationResult,
  useScreen,
} from '@auth0/auth0-acul-react/email-verification-result';

export const useEmailVerificationResultManager = () => {
  const screen = useScreen();
  const emailVerificationResult = useEmailVerificationResult();

  return {
    emailVerificationResult,
    screen,
  };
};
